import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import { Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import {
  setBreadcrumbs,
  reduceServerErrors,
  ConfirmDeletionModal,
  UiToastAdapter,
  GuidelinesCard,
} from 'src/ui';
import { getToken } from 'src/auth';
import { getUser } from 'src/user';
import { getAccount, fetchAccount, deleteAccountObligation } from 'src/account';
import { ObligationsTable } from '../components';

const guidelines = [
  `Use this form to fill out obligation request information.`,
];

const ObligationsListPage = ({
  fetchAccount,
  setBreadcrumbs,
  deleteAccountObligation,
  token,
  user,
  account,
}) => {
  const [loading, setLoading] = React.useState(true);
  const [deletingObligation, setDeletingObligation] = React.useState(null);
  // handlers close over the props of the render they were created in; after
  // an await the request's outcome is only in the latest props
  const accountRef = React.useRef(account);
  accountRef.current = account;

  const onDeleteObligation = obligation => {
    setDeletingObligation(obligation);
  };

  const onCancelDeleteObligation = () => {
    setDeletingObligation(null);
  };

  const onConfirmDeleteObligation = async () => {
    setLoading(true);

    onCancelDeleteObligation();

    await deleteAccountObligation({
      accountId: user.accountId,
      obligationId: deletingObligation.id,
    });

    setLoading(false);

    if (accountRef.current.isError()) {
      return reduceServerErrors(accountRef.current);
    }
    toast(UiToastAdapter('Obligation archived successfully!', 'success'));
    return undefined;
  };

  React.useEffect(() => {
    (async () => {
      setBreadcrumbs([{ label: 'Obligations', href: '/obligations' }]);

      if (token.isValid()) {
        if (user.accountId) {
          await fetchAccount(user.accountId);

          if (accountRef.current.isError()) {
            reduceServerErrors(accountRef.current);
          }
        }
      }

      setLoading(false);
    })();
  }, []);

  return (
    <>
      <Columns isMultiline>
        <Column isSize="1/2">
          <MuiTitle isSize="4" hasTextColor="info" tag="h2">
            Obligations
          </MuiTitle>
        </Column>
        <Column isSize="1/2">
          <NavLink
            className="button is-gradient-bright is-long is-pulled-right"
            to="/obligations/add"
          >
            <span className="icon is-left">
              <FontAwesomeIcon icon={['fal', 'plus']} />
            </span>
            <span>Add Obligation</span>
          </NavLink>
        </Column>
        <Column>
          <ObligationsTable
            loading={loading}
            obligations={account.obligations || []}
            onDeleteObligation={onDeleteObligation}
          />
        </Column>
        {!user.isBankAdmin && !user.isSuperAdmin && (
          <Column isSize="narrow">
            <GuidelinesCard guidelines={guidelines} />
          </Column>
        )}
      </Columns>
      <ConfirmDeletionModal
        isActive={!!deletingObligation}
        onClickCancel={onCancelDeleteObligation}
        onClickConfirm={onConfirmDeleteObligation}
        title={(deletingObligation || {}).obligationCreditor || ''}
      />
    </>
  );
};

ObligationsListPage.propTypes = {
  fetchAccount: propTypes.func.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  deleteAccountObligation: propTypes.func.isRequired,
  token: propTypes.object.isRequired,
  user: propTypes.object.isRequired,
  account: propTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    token: getToken(state),
    user: getUser(state),
    account: getAccount(state),
  };
}

const connectedObligationsListPage = connect(mapStateToProps, {
  fetchAccount,
  setBreadcrumbs,
  deleteAccountObligation,
})(ObligationsListPage);

export { connectedObligationsListPage as ObligationsListPage };
